import { PlanzoneSettings } from "@planzone/dto";

function normalizeSettings(settings: {
  [key: string]: string;
}): PlanzoneSettings {
  return {
    areWeeklyCalendarLockedForNonAdmin:
      settings.areWeeklyCalendarLockedForNonAdmin === "true",
    areTimeSheetsAutoIntegrated:
      settings["pz.timeSheets.autoIntegration"] === "true",
    canEditPersonalTimeSheet:
      settings["pz.timeSheets.canEditPersonalTimeSheet"] === "true",
    canEditProjectPersonalTimeSheet:
      settings["pz.timeSheets.canEditProjectPersonalTimeSheet"] === "true",
    canEditManagerPersonalTimeSheet:
      settings["pz.timeSheets.canEditManagerPersonalTimeSheet"] === "true",
    canApprovePersonalTimeSheet:
      settings["pz.timeSheets.canApprovePersonalTimeSheet"] === "true",
    canApproveProjectPersonalTimeSheet:
      settings["pz.timeSheets.canApproveProjectPersonalTimeSheet"] === "true",
    canApproveManagerPersonalTimeSheet:
      settings["pz.timeSheets.canApproveManagerPersonalTimeSheet"] === "true",
    canWorkersCreateTask:
      settings["pz.security.createTasksByWorkers"] === "true",
    canWorkersEditTask: settings["pz.security.updateTasksByWorkers"] === "true",
    canWorkersRemoveTask:
      settings["pz.security.deleteTasksByWorkers"] === "true",
    canWorkersCreateList:
      settings["pz.security.createActivitiesByWorkers"] === "true",
    canWorkersEditList:
      settings["pz.security.updateActivitiesByWorkers"] === "true",
    canWorkersRemoveList:
      settings["pz.security.deleteActivitiesByWorkers"] === "true",
    canWorkersCreateMilestone:
      settings["pz.security.createMilestonesByWorkers"] === "true",
    canWorkersEditMilestone:
      settings["pz.security.updateMilestonesByWorkers"] === "true",
    canWorkersRemoveMilestone:
      settings["pz.security.deleteMilestonesByWorkers"] === "true",
    canWorkersCreateEvent:
      settings["pz.security.createEventsByWorkers"] === "true",
    canWorkersEditEvent:
      settings["pz.security.updateEventsByWorkers"] === "true",
    canWorkersRemoveEvent:
      settings["pz.security.deleteEventsByWorkers"] === "true",
    areProjectStatsHiddenInProjectListing:
      settings["areProjectStatsHiddenInProjectListing"] === "true",
    areUsersNotifiedAfterAccountCreation:
      settings["pz.notifications.notifyUsersAfterAccountCreation"] === "true",
    canUseOnlyOffice: settings["pz.document.onlyOffice"] === "true",
    canUseResourceUsageReport: settings["pz.report.usageReport"] === "true",
    conserveElementDuration:
      settings["pz.project.conserveElementDuration"] === "true",
    showTaskCompletionPercentage:
      settings["pz.timesheetsColumnVisibility.showTaskCompletionPercentage"] ===
      "true",
    allowDataScrapingForDebug: settings["allowDataScrapingForDebug"] === "true",
    enterTimeAllocationInDays: settings["enterTimeAllocationInDays"] === "true",
    enableSelfAssignment:
      settings["pz.timeSheets.enableSelfAssignment"] === "true",
    lockBeforeIntegrationDate:
      settings["pz.timesheet.lockBeforeIntegrationDate"] === "true",
    syncAllocationDurationWithTask:
      settings["pz.task.syncAllocationDuration"] === "true",
    warnOnDailyCriticalAmplitude:
      settings["pz.allocation.warnOnDailyCriticalAmplitude"] === "true",
    warnOnDailyCriticalVolume:
      settings["pz.allocation.warnOnDailyCriticalVolume"] === "true",
    warnOnInsufficientRestPeriod:
      settings["pz.allocation.warnOnInsufficientRestPeriod"] === "true",
    warnOnUnavailability:
      settings["pz.allocation.warnOnUnavailability"] === "true",
  };
}

function serializeSettings(settings: PlanzoneSettings): {
  [key: string]: string;
} {
  return {
    areWeeklyCalendarLockedForNonAdmin:
      settings.areWeeklyCalendarLockedForNonAdmin ? "true" : "false",
    "pz.timeSheets.autoIntegration": settings.areTimeSheetsAutoIntegrated
      ? "true"
      : "false",
    "pz.timeSheets.canEditPersonalTimeSheet": settings.canEditPersonalTimeSheet
      ? "true"
      : "false",
    "pz.timeSheets.canEditProjectPersonalTimeSheet":
      settings.canEditProjectPersonalTimeSheet ? "true" : "false",
    "pz.timeSheets.canEditManagerPersonalTimeSheet":
      settings.canEditManagerPersonalTimeSheet ? "true" : "false",
    "pz.timeSheets.canApprovePersonalTimeSheet":
      settings.canApprovePersonalTimeSheet ? "true" : "false",
    "pz.timeSheets.canApproveProjectPersonalTimeSheet":
      settings.canApproveProjectPersonalTimeSheet ? "true" : "false",
    "pz.timeSheets.canApproveManagerPersonalTimeSheet":
      settings.canApproveManagerPersonalTimeSheet ? "true" : "false",
    "pz.security.createTasksByWorkers": settings.canWorkersCreateTask
      ? "true"
      : "false",
    "pz.security.updateTasksByWorkers": settings.canWorkersEditTask
      ? "true"
      : "false",
    "pz.security.deleteTasksByWorkers": settings.canWorkersRemoveTask
      ? "true"
      : "false",
    "pz.security.createActivitiesByWorkers": settings.canWorkersCreateList
      ? "true"
      : "false",
    "pz.security.updateActivitiesByWorkers": settings.canWorkersEditList
      ? "true"
      : "false",
    "pz.security.deleteActivitiesByWorkers": settings.canWorkersRemoveList
      ? "true"
      : "false",
    "pz.security.createMilestonesByWorkers": settings.canWorkersCreateMilestone
      ? "true"
      : "false",
    "pz.security.updateMilestonesByWorkers": settings.canWorkersEditMilestone
      ? "true"
      : "false",
    "pz.security.deleteMilestonesByWorkers": settings.canWorkersRemoveMilestone
      ? "true"
      : "false",
    "pz.security.createEventsByWorkers": settings.canWorkersCreateEvent
      ? "true"
      : "false",
    "pz.security.updateEventsByWorkers": settings.canWorkersEditEvent
      ? "true"
      : "false",
    "pz.security.deleteEventsByWorkers": settings.canWorkersRemoveEvent
      ? "true"
      : "false",
    areProjectStatsHiddenInProjectListing:
      settings.areProjectStatsHiddenInProjectListing ? "true" : "false",
    "pz.notifications.notifyUsersAfterAccountCreation":
      settings.areUsersNotifiedAfterAccountCreation ? "true" : "false",
    "pz.document.onlyOffice": settings.canUseOnlyOffice ? "true" : "false",
    "pz.report.usageReport": settings.canUseResourceUsageReport
      ? "true"
      : "false",
    "pz.project.conserveElementDuration": settings.conserveElementDuration
      ? "true"
      : "false",
    "pz.timesheetsColumnVisibility.showTaskCompletionPercentage":
      settings.showTaskCompletionPercentage ? "true" : "false",
    allowDataScrapingForDebug: settings.allowDataScrapingForDebug
      ? "true"
      : "false",
    enterTimeAllocationInDays: settings.enterTimeAllocationInDays
      ? "true"
      : "false",
    "pz.timeSheets.enableSelfAssignment": settings.enableSelfAssignment
      ? "true"
      : "false",
    "pz.timesheet.lockBeforeIntegrationDate": settings.lockBeforeIntegrationDate
      ? "true"
      : "false",
    "pz.task.syncAllocationDuration": settings.syncAllocationDurationWithTask
      ? "true"
      : "false",
    "pz.allocation.warnOnDailyCriticalAmplitude":
      settings.warnOnDailyCriticalAmplitude ? "true" : "false",
    "pz.allocation.warnOnDailyCriticalVolume":
      settings.warnOnDailyCriticalVolume ? "true" : "false",
    "pz.allocation.warnOnInsufficientRestPeriod":
      settings.warnOnInsufficientRestPeriod ? "true" : "false",
    "pz.allocation.warnOnUnavailability": settings.warnOnUnavailability
      ? "true"
      : "false",
  };
}

export { normalizeSettings, serializeSettings };
